import { FunctionComponent, MouseEvent, ReactNode } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { OrderMethod } from '@/libs/helpers/utils'
import { useSearch } from '@/providers/state/search'
import { Button, Grid, SvgIcon } from '@/tbui'

import VenueAutocompleteComponent from './VenueAutocompleteComponent'

const StyledGrid = styled(Grid)`
  border-radius: ${(props) => props.theme.shape.RADIUS};
  background: ${(props) => props.theme.palette.WHITE};
  max-width: ${(props) => props.theme.breakpoints.SM};
  box-shadow: ${(props) => props.theme.shape.SHADOW};
  grid-template-columns: auto 1fr auto;
  align-items: center;
  display: grid;
  padding: 4px;
  width: 100%;
  gap: 8px;
`

const StyledSvgIcon = styled(SvgIcon)`
  font-size: 20px;
  margin: 8px;
`

const StyledButton = styled(Button)`
  @media (max-width: ${(props) => props.theme.breakpoints.SM}) {
    display: none;
  }
`

const SearchInputByVenue: FunctionComponent<{ orderMethod: OrderMethod }> = ({ orderMethod }) => {
  const [{ orderingVenue }, { setOrderMethod }] = useSearch()
  const { t } = useTranslation()

  const handleSubmit = (e: MouseEvent): void => {
    e.preventDefault()
    if (orderingVenue) {
      setOrderMethod(orderMethod)
    }
  }

  const renderInputSection = (): ReactNode => {
    return (
      <>
        <StyledSvgIcon name="search" color="PRIMARY" fontSize="20px" />
        <VenueAutocompleteComponent
          label={t('tbdine.search_input.restaurant')}
          orderMethod={orderMethod}
        />
      </>
    )
  }

  const renderButtonsSection = (): ReactNode => {
    return (
      <StyledButton big onClick={handleSubmit}>
        {t('tbdine.search_input.search')}
      </StyledButton>
    )
  }

  return (
    <StyledGrid data-test="search-venue">
      {renderInputSection()}
      {renderButtonsSection()}
    </StyledGrid>
  )
}

export default SearchInputByVenue
